import { render, staticRenderFns } from "./CoachSwiper.vue?vue&type=template&id=2172015d&lang=pug"
import script from "./CoachSwiper.vue?vue&type=script&lang=js"
export * from "./CoachSwiper.vue?vue&type=script&lang=js"
import style0 from "./CoachSwiper.vue?vue&type=style&index=0&id=2172015d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports